import styled from "@emotion/styled";
export const TabListRoot = styled.div`
  overflow-x: auto;
`;
export const TabListContent = styled.div`
  display: flex;
  gap: 1rem;
`;
